import { Box, Typography, ToggleButtonGroup, ToggleButton } from '@mui/material';
import { BugReport, Lightbulb } from '@mui/icons-material';

export default function FeedbackTypePicker({ type, onChange, disabled = false }) {
  return (
    <Box>
      <Typography variant="subtitle2" fontWeight={700} sx={{ mb: 1 }}>
        Feedback Type
      </Typography>
      <ToggleButtonGroup
        value={type}
        exclusive
        onChange={onChange}
        fullWidth
        size="small"
        aria-label="Feedback type"
        disabled={disabled}
      >
        <ToggleButton
          value="bug"
          aria-label="Bug report"
          sx={{
            fontWeight: 700,
            textTransform: 'none',
            gap: 1,
            '&.Mui-selected': {
              bgcolor: 'error.50',
              color: 'error.dark',
              borderColor: 'error.light',
              '&:hover': { bgcolor: 'error.100' },
            },
          }}
        >
          <BugReport fontSize="small" />
          Bug Report
        </ToggleButton>
        <ToggleButton
          value="feature"
          aria-label="Feature request"
          sx={{
            fontWeight: 700,
            textTransform: 'none',
            gap: 1,
            '&.Mui-selected': {
              bgcolor: 'primary.50',
              color: 'primary.dark',
              borderColor: 'primary.light',
              '&:hover': { bgcolor: 'primary.100' },
            },
          }}
        >
          <Lightbulb fontSize="small" />
          Feature Request
        </ToggleButton>
      </ToggleButtonGroup>
    </Box>
  );
}
